function addHours(date, hours) {
  const dateCopy = new Date(date.getTime());
  const hoursToAdd = hours * 60 * 60 * 1000;
  dateCopy.setTime(date.getTime() + hoursToAdd);
  return dateCopy;
}

function parseDuration(durationString) {
  const dayComponent = durationString.includes('T')
    ? durationString.split('T')[0]
    : durationString;

  const hourComponent = durationString.includes('T')
    ? durationString.split('T')[1]
    : '';

  const days = dayComponent.replace('P', '').replace('D', '');
  const hours = hourComponent.replace('H', '');
  return (parseInt(days) || 0) * 24 + (parseInt(hours) || 0);
}

function timeAndDuration(timeString) {
  const timeComponents = timeString.split('/'); // "2025-11-02T16:00:00+00:00/PT2H";
  const isoTimestamp = timeComponents[0]; // "2025-11-02T16:00:00+00:00"
  const durationString = timeComponents[1]; // "PT2H", "P1DT9H"

  const time = new Date(isoTimestamp);
  const duration = parseDuration(durationString);

  return { time, duration };
}

export function decompressData(values) {
  let decompressedValues = [];

  values.forEach(function (value) {
    const { time, duration } = timeAndDuration(value['validTime']);
    for (let i = 0; i < duration; i++) {
      decompressedValues.push({
        validTime: addHours(time, i),
        value: value['value'],
      });
    }
  });

  return decompressedValues;
}

export function interpolateData(values) {
  let interpolatedValues = [];

  values.forEach(function (value) {
    const { time, duration } = timeAndDuration(value['validTime']);
    const increment = value['value'] / duration;

    for (let i = 0; i < duration; i++) {
      interpolatedValues.push({
        validTime: addHours(time, i),
        value: increment,
      });
    }
  });

  return interpolatedValues;
}

export function imputeData(values) {
  let imputedValues = [];

  values.forEach(function (value) {
    const { time, duration } = timeAndDuration(value['validTime']);

    imputedValues.push({
      validTime: time,
      value: value['value'],
    });

    for (let i = 1; i < duration; i++) {
      imputedValues.push({
        validTime: addHours(time, i),
        value: null,
      });
    }
  });

  return imputedValues;
}

export function cumulativeSum(arr) {
  let result = [];
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
    result.push(sum);
  }
  return result;
}

function mean(array) {
  if (array.length === 0) return null;
  const sum = array.reduce((acc, val) => acc + val, 0);
  return sum / array.length;
}

export function resample(data, times) {
  let resampledValues = [];

  // Use the mode value for each 6 hour interval
  for (let i = 0; i < data.length - 3; i += 6) {
    let intervalValues = data.slice(i, i + 6);

    resampledValues.push({
      time: times[i + 3],
      value: mean(intervalValues),
    });
  }
  return resampledValues;
}
